import { render, staticRenderFns } from "./symposium.vue?vue&type=template&id=2365e7a6&scoped=true&"
import script from "./symposium.vue?vue&type=script&lang=js&"
export * from "./symposium.vue?vue&type=script&lang=js&"
import style0 from "./symposium.vue?vue&type=style&index=0&id=2365e7a6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2365e7a6",
  null
  
)

component.options.__file = "symposium.vue"
export default component.exports